var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// these sizes are arbitrary and you can set them to whatever you wish
import { css } from 'styled-components';
var sizes = {
    desktopL: 1270,
    desktop: 992,
    tablet: 768,
    phone: 576,
};
// Iterate through the sizes and create a media template
export var media = Object.keys(sizes).reduce(function (acc, label) {
    acc[label] = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (max-width: ", "em) {\n      ", ";\n    }\n  "], ["\n    @media (max-width: ", "em) {\n      ", ";\n    }\n  "])), sizes[label] / 16, css.apply(void 0, args));
    };
    return acc;
}, {});
var templateObject_1;
// Note the usage of min-width instead of usual max-width, as
// I believe in mobile-first development, so the media queries
// are setup to match bootstrap behaviours
// Sample usage --
/* eslint-disable no-unused-vars */
// const Container = styled.div`
//   color: #333;
//   ${media.phone`padding: 0 5px;`}
//   ${media.tablet`padding: 0 10px;`}
//   ${media.desktop`padding: 0 20px;`}
// `;
// ----------------
